import { z } from 'zod';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowScriptedBlockConfigSchema = z.object({
    fn: z.string().min(1, {
        message: 'Script is required.',
    }),
});
export const FlowScriptedBlockBaseSchema = z.object({
    type: z.literal(FlowBlockType.ScriptedFlow),
    config: FlowScriptedBlockConfigSchema,
});
export const FlowScriptedBlockSchema = BaseFlowBlockSchema.extend(FlowScriptedBlockBaseSchema.shape);
//# sourceMappingURL=config.js.map